import { defineComponent as _defineComponent } from 'vue'
import RequestFeature from '@/views/Automation/CampaignCreatorV2/components/CcRequestFeature/RequestFeature.ts.vue';

interface Option {
  text: string;
  info?: string;
  value: string;
  disabled?: boolean;
  requestFeature?: boolean;
  id: string;
}

interface Props {
  id: string;
  disabled?: boolean;
  options?: Option[];
  value?: string;
}

interface Emits {
  (event: 'update', value: string): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CcRadioGroupText.ts',
  props: {
    id: null,
    disabled: { type: Boolean, default: false },
    options: { default: () => [] },
    value: { default: '' }
  },
  emits: ["update"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: 'update', value: string): void;
}), expose: any, slots: any, attrs: any }) {





function onRadioButtonClick(value: string) {
  emits('update', value);
}

return { __sfc: true,emits, onRadioButtonClick, RequestFeature }
}

})